import { useState } from 'react'
import { useContentApi } from 'hooks/use-content-api/useContentApi'
import { BackendContent } from 'common/types'
import { useLocation } from 'react-router-dom'

export const useFooterNav = () => {
  const { createContent } = useContentApi()
  const [showLoader, setShowLoader] = useState(false)
  const { pathname } = useLocation()
  
  const forceUpdate = () => {
    if (pathname === '/feed') {
      window.scrollTo(0, 0)
      window.location.reload()
    }
  }

  const handleCreateContent = async (userId: string, content: BackendContent) => {
    const response = await createContent(userId, content)
    if (response) forceUpdate()
    return response
  }

  return {
    createContent: handleCreateContent,
    showLoader,
    setShowLoader,
    forceUpdate
  } as const
}
